"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var Fab_1 = __importDefault(require("@material-ui/core/Fab"));
var Person_1 = __importDefault(require("@material-ui/icons/Person"));
var core_1 = require("@material-ui/core");
var styles_1 = require("@material-ui/core/styles");
var AccountTree_1 = __importDefault(require("../AccountTree/AccountTree"));
var Theme_1 = __importStar(require("./Theme"));
var getBranding_1 = __importDefault(require("./getBranding"));
var jumpToAccount_1 = __importDefault(require("./jumpToAccount"));
var FullPageSpinner_1 = __importDefault(require("../FullPageSpinner/FullPageSpinner"));
var AccountEntry_1 = __importDefault(require("../AccountEntry/AccountEntry"));
var LoginAvatar_css_1 = __importDefault(require("./LoginAvatar-css"));
var ChangePassword_1 = __importDefault(require("./ChangePassword"));
var Button_1 = __importDefault(require("../Button/Button"));
var NotificationBar_1 = __importDefault(require("../NotificationBar/NotificationBar"));
var LoginAvatar = /** @class */ (function (_super) {
    __extends(LoginAvatar, _super);
    function LoginAvatar() {
        var _this = _super.call(this) || this;
        _this.handleClick = function (event) {
            _this.setState({ anchorEl: event.currentTarget });
        };
        _this.handleClose = function () {
            _this.setState({ anchorEl: null });
        };
        _this.toggleJumpDialog = function () {
            _this.setState(function (prevState) {
                return {
                    jumpDialogOpen: !prevState.jumpDialogOpen,
                    jumpClient: null,
                    anchorEl: null,
                    jumpError: false
                };
            });
        };
        _this.componentDidMount = function () {
            var nmLogin = function () {
                return fetch("/getToken", {
                    method: "GET",
                    credentials: "include"
                })
                    .then(function (res) { return res.json(); })
                    .then(function (res) { var _a; return (_a = res === null || res === void 0 ? void 0 : res.response) === null || _a === void 0 ? void 0 : _a.jwt; });
            };
            if (process.env.NODE_ENV === "development") {
                nmLogin = function () {
                    return Promise.resolve("eyJhbGciOiJIUzUxMiJ9.eyJ1c2VyaWQiOiIxNzA5OCIsInVzZXJjbGllbnQiOiIyMDQxMDgiLCJ1c2VybmFtZSI6ImVsbGlvdHQuMjA0MTA4QGludm9zeXMuY29tIn0.HWxqzkVw3PrfCp7_isJdMKhr1pkumSSKikyZxso-3KkoHHu7eSlMPU8dSf2iv47h-OZrvJoPnakDuq6oRWUFbA");
                };
            }
            var existingJWT = document.cookie
                .split("; ")
                .find(function (cookie) { return cookie.indexOf("JWT=") === 0; });
            if (existingJWT) {
                nmLogin = function () { return Promise.resolve(existingJWT.split("=")[1]); };
            }
            nmLogin()
                .then(function (res) { return _this.setState({ jwt: res }); })
                .then(function () {
                getBranding_1.default(_this.state.jwt, window.location.hostname)
                    .then(function (colorRes) {
                    if (colorRes.primaryColor) {
                        Theme_1.default.palette.primary.main = colorRes.primaryColor;
                        Theme_1.default.palette.secondary.main = colorRes.secondaryColor;
                        Theme_1.darkTheme.palette.primary.main = colorRes.primaryColor;
                        Theme_1.darkTheme.palette.secondary.main = colorRes.secondaryColor;
                    }
                    _this.setState({
                        customTheme: core_1.createTheme(Theme_1.default),
                        customDarkTheme: core_1.createTheme(Theme_1.darkTheme)
                    });
                })
                    .catch(function (error) { return console.debug(error); });
            });
            if (_this.props.passwordAge > 84 && _this.props.passwordAge <= 90) {
                _this.notifications.current.enqueueNotification({
                    message: "Your password is due to expire in " + (91 - _this.props.passwordAge) + " day(s). Please consider changing it now.",
                    actionLabel: "Change Password",
                    type: "info",
                    enableClickAway: true,
                    autoHideDuration: 10000,
                    actionMethod: function () { return _this.changePassword(); },
                    anchorOrigin: { vertical: "bottom" }
                });
            }
            _this.setState({ passwordAge: _this.props.passwordAge });
        };
        _this.changePassword = function () {
            _this.setState({ showChangePassword: true, anchorEl: null });
        };
        _this.setJumpClient = function (targetClient) {
            _this.setState({
                jumpClient: targetClient !== Number(_this.props.currentClientId)
                    ? targetClient
                    : null
            });
        };
        _this.jumpAccount = function () {
            _this.setState({ jumping: true, jumpError: false });
            jumpToAccount_1.default(_this.state.jumpClient)
                .then(function (res) {
                try {
                    if (res.response.status === "OK") {
                        window.location.reload();
                    }
                    else {
                        _this.setState({ jumpError: true, jumping: false });
                    }
                }
                catch (e) {
                    _this.setState({ jumpError: true, jumping: false });
                }
            })
                .catch(function () {
                _this.setState({ jumpError: true, jumping: false });
            });
        };
        _this.notifications = react_1.default.createRef();
        _this.state = {
            anchorEl: null,
            jumpDialogOpen: false,
            jumpClient: null,
            jumping: false,
            customTheme: core_1.createTheme(Theme_1.default),
            customDarkTheme: core_1.createTheme(Theme_1.darkTheme),
            jumpError: false
        };
        return _this;
    }
    LoginAvatar.prototype.render = function () {
        var _this = this;
        var anchorEl = this.state.anchorEl;
        var open = Boolean(anchorEl);
        // const internalClasses = useStyles();
        var _a = this.props, displayName = _a.displayName, isSysAdmin = _a.isSysAdmin, isAdministrator = _a.isAdministrator, hasChildren = _a.hasChildren;
        return (react_1.default.createElement(core_1.MuiThemeProvider, { theme: this.state.customDarkTheme },
            react_1.default.createElement("div", null,
                react_1.default.createElement(core_1.Grid, { container: true, alignItems: "center", style: { width: "inherit" } },
                    react_1.default.createElement(core_1.Grid, { item: true },
                        react_1.default.createElement(core_1.Typography, null, this.props.clientName)),
                    react_1.default.createElement(core_1.Grid, { item: true, style: { width: "0.5em" } }),
                    react_1.default.createElement(core_1.Grid, { item: true },
                        react_1.default.createElement(Fab_1.default, { size: "small", "aria-label": "More", "aria-owns": open ? "long-menu" : undefined, "aria-haspopup": "true", onClick: this.handleClick },
                            react_1.default.createElement(Person_1.default, null)))),
                react_1.default.createElement(core_1.MuiThemeProvider, { theme: this.state.customTheme },
                    react_1.default.createElement(core_1.Popover, { id: "long-menu", anchorEl: anchorEl, open: open, onClose: function () {
                            _this.setState({ anchorEl: null });
                        }, anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "right"
                        }, transformOrigin: {
                            vertical: "top",
                            horizontal: "right"
                        } },
                        react_1.default.createElement(core_1.List, { dense: true },
                            react_1.default.createElement(core_1.MuiThemeProvider, { theme: this.state.customDarkTheme },
                                react_1.default.createElement(core_1.Paper, { elevation: 0, square: true },
                                    react_1.default.createElement(core_1.ListItem, { divider: true },
                                        react_1.default.createElement(core_1.Typography, null,
                                            "Hello ",
                                            displayName)))),
                            (isSysAdmin || isAdministrator) && hasChildren && (react_1.default.createElement("span", { style: LoginAvatar_css_1.default["invosys-ui-LoginAvatar-styledLink"] },
                                react_1.default.createElement(core_1.ListItem, { divider: true, onClick: this.toggleJumpDialog },
                                    react_1.default.createElement(core_1.Typography, null, "Administer different account")))),
                            !isSysAdmin && (react_1.default.createElement(core_1.ListItem, { divider: true, onClick: this.changePassword },
                                react_1.default.createElement(core_1.Typography, null, "Change Password"))),
                            (this.props.listActions || []).map(function (action, index) { return (react_1.default.createElement(core_1.ListItem, { key: index, onClick: function () {
                                    _this.setState({ anchorEl: null }, function () {
                                        action.method();
                                    });
                                } }, action.name)); }),
                            this.props.logoutAction ? (react_1.default.createElement(core_1.ListItem, { onClick: function () {
                                    _this.setState({ anchorEl: null }, function () {
                                        _this.props.logoutAction();
                                    });
                                }, divider: !!this.props.apps },
                                react_1.default.createElement(core_1.Typography, null, "Log Out"))) : (react_1.default.createElement(core_1.ListItem, { component: core_1.Link, href: "/logout", color: "inherit", onClick: this.props.logoutAction, divider: !!this.props.apps },
                                react_1.default.createElement(core_1.Typography, null, "Log Out"))),
                            this.props.apps && (react_1.default.createElement(core_1.ListItem, null,
                                react_1.default.createElement(core_1.Grid, { container: true, style: { width: "150px" } }, this.props.apps.map(function (app, idx) { return (react_1.default.createElement(core_1.Grid, { item: true, xs: 4, key: "" + app.title + idx },
                                    react_1.default.createElement(core_1.IconButton, { href: app.link, target: app.target || "_blank", color: app.color || "secondary" }, app.icon),
                                    app.title && (react_1.default.createElement(core_1.Typography, { variant: "caption", style: { textAlign: "center", display: "block" } }, app.title)))); })))))),
                    (this.state.showChangePassword ||
                        (this.state.passwordAge > 90 && this.state.jwt)) && (react_1.default.createElement(ChangePassword_1.default, { open: true, closeMethod: function () {
                            _this.setState({ showChangePassword: false, passwordAge: 0 });
                            if (_this.props.passwordAge > 85) {
                                fetch("/reset-password-age");
                                document.querySelector("input[name='react.passwordAge']").value = "0";
                            }
                        }, jwt: this.state.jwt, auditUserEmail: this.props.auditUserEmail, auditUserId: this.props.auditUserId, passwordAge: this.props.passwordAge })),
                    react_1.default.createElement(core_1.Dialog, { open: this.state.jumpDialogOpen, scroll: "paper", maxWidth: "sm", fullWidth: true },
                        react_1.default.createElement(core_1.DialogTitle, null, "Select Account to administer"),
                        react_1.default.createElement(core_1.DialogContent, null,
                            react_1.default.createElement(FullPageSpinner_1.default, { loading: this.state.jumping }),
                            this.props.clientId !== "1001" && (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement(core_1.TextField, { fullWidth: true, onChange: function (evt) {
                                        var value = evt.target.value;
                                        _this.setState({
                                            accountSearch: value.length > 2 ? value : ""
                                        });
                                    }, label: "Search", placeholder: "Type name to search (min 3 chars.)" }),
                                react_1.default.createElement(AccountTree_1.default, { searchClientId: this.props.clientId, selectedClientId: this.props.currentClientId, targetClientId: this.state.jumpClient, accountClick: this.setJumpClient, filterString: this.state.accountSearch }))),
                            this.props.clientId === "1001" && (react_1.default.createElement(AccountEntry_1.default, { targetClientId: this.state.jumpClient, accountChange: this.setJumpClient, jumpError: this.state.jumpError }))),
                        react_1.default.createElement(core_1.DialogActions, null,
                            react_1.default.createElement(Button_1.default, { onClick: this.toggleJumpDialog, disabled: this.state.jumping, variant: "outlined" }, "Cancel"),
                            react_1.default.createElement(Button_1.default, { onClick: this.jumpAccount, disabled: this.state.jumpClient == null || this.state.jumping, color: "primary", variant: "contained", inProgress: this.state.jumping }, "Confirm"))),
                    react_1.default.createElement(NotificationBar_1.default, { ref: this.notifications })))));
    };
    return LoginAvatar;
}(react_1.default.Component));
LoginAvatar.propTypes = {
    displayName: prop_types_1.default.string,
    isSysAdmin: prop_types_1.default.bool,
    isAdministrator: prop_types_1.default.bool,
    clientId: prop_types_1.default.string,
    clientName: prop_types_1.default.string,
    currentClientId: prop_types_1.default.string,
    hasChildren: prop_types_1.default.bool,
    apps: prop_types_1.default.array,
    logoutAction: prop_types_1.default.func,
    listActions: prop_types_1.default.array,
    passwordAge: prop_types_1.default.number,
    auditUserId: prop_types_1.default.number,
    auditUserEmail: prop_types_1.default.string
};
exports.default = styles_1.withTheme(LoginAvatar);
